import { render } from "./bookCreate.vue?vue&type=template&id=da77a17c"
import script from "./bookCreate.vue?vue&type=script&lang=js"
export * from "./bookCreate.vue?vue&type=script&lang=js"

import "./bookCreate.vue?vue&type=style&index=0&id=da77a17c&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__